let hierarchyCache = null;

export const loadHierarchyLookup = async () => {
  if (hierarchyCache) {
    console.log('📋 Using cached hierarchy lookup');
    return hierarchyCache;
  }

  try {
    console.log('📚 Loading hierarchy lookup for Inventory Analysis...');
    const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5001';
    const response = await fetch(`${API_BASE}/data/2024%20COMPLETE%20ACH%20MCH%20HIERARCHY_Material%20Group%20Look-Up%20Table%28VALID%20HIERARCHY%29.csv`);
    
    if (!response.ok) {
      console.warn('⚠️ Hierarchy file not found:', response.status);
      return new Map();
    }
    
    const text = await response.text();
    console.log('📄 CSV file loaded, size:', text.length, 'characters');
    
    const lines = text.split('\n').filter(line => line.trim());
    console.log('📊 CSV lines found:', lines.length);
    
    // Column indices (0-based)
    const productLineIdx = 7; // Column H - PRODUCT LINE  
    const departmentIdx = 8; // Column I - DEPARTMENT
    const classIdx = 9; // Column J - CLASS
    
    const classToHierarchyLookup = new Map();
    
    // Process each row (skip header)
    for (let i = 1; i < lines.length; i++) {
      const row = lines[i].split(',');
      if (row.length > classIdx) {
        const className = row[classIdx]?.trim();
        const department = row[departmentIdx]?.trim();
        const productLine = row[productLineIdx]?.trim();
        
        if (className && (department || productLine)) {
          classToHierarchyLookup.set(className, {
            department: department || 'Unknown',
            productLine: productLine || 'Unknown'
          });
        }
      }
    }
    
    console.log('✅ Hierarchy lookup loaded:', classToHierarchyLookup.size, 'class→hierarchy mappings');
    console.log('📝 Sample mappings:', Array.from(classToHierarchyLookup.entries()).slice(0, 5));
    
    hierarchyCache = classToHierarchyLookup;
    return classToHierarchyLookup;
  } catch (error) {
    console.error('❌ Error loading hierarchy:', error);
    return new Map();
  }
};

export const getDepartmentFromClass = (className, hierarchyLookup) => {
  if (!className || !hierarchyLookup) {
    return 'Unknown';
  }
  
  const cleanClassName = String(className).trim();
  
  if (hierarchyLookup.has(cleanClassName)) {
    const hierarchyData = hierarchyLookup.get(cleanClassName);
    // Return department for backwards compatibility
    return hierarchyData.department || 'Unknown';
  }
  
  // Fallback
  return 'Unknown';
};

export const getHierarchyFromClass = (className, hierarchyLookup) => {
  if (!className || !hierarchyLookup) {
    return { department: 'Unknown', productLine: 'Unknown' };
  }
  
  const cleanClassName = String(className).trim();
  
  if (hierarchyLookup.has(cleanClassName)) {
    return hierarchyLookup.get(cleanClassName);
  }
  
  // Fallback
  return { department: 'Unknown', productLine: 'Unknown' };
};

// Clear cache function for testing
export const clearHierarchyCache = () => {
  hierarchyCache = null;
};